// assets
import { DashboardOutlined, ChromeOutlined, UnorderedListOutlined, DotChartOutlined, BarChartOutlined } from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  ChromeOutlined,
  UnorderedListOutlined,
  DotChartOutlined,
  BarChartOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'review-list',
      title: 'Review List',
      type: 'item',
      url: '/review-list',
      icon: icons.UnorderedListOutlined
    },
    {
      id: 'sentiment-analytics',
      title: 'Sentiment Analytics',
      type: 'item',
      url: '/sentiment-analytics',
      icon: icons.BarChartOutlined
    },
    {
      id: 'cron-configuration',
      title: 'Schedule Auto Emails',
      type: 'item',
      url: '/cron-create',
      icon: icons.BarChartOutlined
    }
  ]
};

export default dashboard;
